import { render } from "./expend.vue?vue&type=template&id=718bd202&scoped=true&ts=true"
import script from "./expend.vue?vue&type=script&lang=ts"
export * from "./expend.vue?vue&type=script&lang=ts"

import "./expend.vue?vue&type=style&index=0&id=718bd202&scoped=true&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718bd202"]])

export default __exports__